/* eslint-disable @typescript-eslint/no-explicit-any */
import { Component, forwardRef, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR } from '@angular/forms';

import { DropDownItem } from '../../filters/filter.interface';

@Component({
  selector: 'claim-panel-select',
  templateUrl: './claims-panel-select.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => {
        return ClaimsPanelSelectComponent;
      }),
      multi: true,
    },
  ],
})
export class ClaimsPanelSelectComponent {
  @Input() disabled = false;
  @Input() class = '';
  @Input() placeholder = 'Select Panel Info';
  @Input() required = false;

  value = '';
  panelsOptions: DropDownItem[] = [
    {
      key: 'keyfields',
      value: 'Key Fields',
    },
    {
      key: 'inputClaim',
      value: 'Input File',
    },
    {
      key: 'outputClaim',
      value: 'Output Claim',
    },
    {
      key: 'errors',
      value: 'Claim Errors',
    },
    {
      key: 'inputFile',
      value: 'Input File',
    },
    {
      key: 'transmit',
      value: 'Transmit/Print File',
    },
    {
      key: 'remittance',
      value: 'Remittance',
    },
  ];

  //#region ControlValueAccessor

  writeValue(value: any) {
    this.value = value ? value : '';
  }

  setDisabledState(isDisabled: boolean) {
    this.disabled = isDisabled;
  }

  //#endregion
}
